import React from 'react'

import { theme } from '@acorns/grove'
import { AcornsIcon } from '@acorns/icons'
import { Bold } from '@acorns/web-components'
import { useAnalyticsClient, useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { trackAiChatFaqArticleButtonTappedPayload } from 'generated/trackingEvents'
import { SupportCitation } from 'generated/types'

import { AI_CHAT_FEEDBACK_ORIGIN } from './utils/constants'

const CitationsContainer = styled.div`
  margin: 20px 0px 20px 50px;
`

const CitationsTitle = styled(Bold)`
  margin-bottom: 15px;
  margin-top: 0;
`

const CitationItem = styled.div`
  border-bottom: 1px solid ${theme.colors.primaryIvory};
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  user-select: none;
  &:last-child {
    border-bottom: none;
  }
`

const CitationTitle = styled.div`
  font-size: 14px;
  color: ${theme.colors.primarySlate};
  flex: 1;
  font-weight: 500;
`

const ChevronIcon = styled(AcornsIcon)`
  width: 12px;
  height: 12px;
  color: ${theme.colors.primaryStoneLight};
`

const BASE_SUPPORT_CITATION_URL =
  'https://support.acorns.com/hc/en-us/articles/'

export const Citations = ({ citations }: { citations: SupportCitation[] }) => {
  const { getRemoteString } = useRemoteStrings()
  const { track } = useAnalyticsClient()

  if (citations.length === 0) {
    return null
  }

  const handleClickLink = (citation: SupportCitation) => () => {
    const citationUrl = `${BASE_SUPPORT_CITATION_URL}${citation.id}`
    window.open(citationUrl, '_blank')

    track(
      ...trackAiChatFaqArticleButtonTappedPayload({
        origin: AI_CHAT_FEEDBACK_ORIGIN,
        ctaTitle: citation.title,
        url: citationUrl,
      }),
    )
  }

  return (
    <CitationsContainer>
      <CitationsTitle>
        {getRemoteString({
          key: 'acorns_intelligence.chat.message.faqs.header',
        })}
      </CitationsTitle>
      {citations.map((citation) => {
        return (
          <CitationItem key={citation.id} onClick={handleClickLink(citation)}>
            <CitationTitle>{citation.title}</CitationTitle>
            <ChevronIcon icon={AcornsIcon.Icon.ChevronRight} />
          </CitationItem>
        )
      })}
    </CitationsContainer>
  )
}
